/**
 * Persistenz von Chat-Messages und Flow-State in localStorage.
 * Keys: ai.chat.messages.v1, ai.chat.flow.v1
 */

const MESSAGES_KEY = "ai.chat.messages.v1";
const FLOW_KEY = "ai.chat.flow.v1";

/**
 * @param {Array<{ id: string; role: string; content: string; [k: string]: unknown }>} messages
 */
export function saveMessages(messages) {
  try {
    if (typeof window === "undefined" || !window.localStorage) return;
    window.localStorage.setItem(MESSAGES_KEY, JSON.stringify(messages ?? []));
  } catch (_) {
    // ignore
  }
}

/**
 * @returns {Array<{ id: string; role: string; content: string; [k: string]: unknown }>}
 */
export function loadMessages() {
  try {
    if (typeof window === "undefined" || !window.localStorage) return [];
    const raw = window.localStorage.getItem(MESSAGES_KEY);
    if (raw == null) return [];
    const parsed = JSON.parse(raw);
    return Array.isArray(parsed) ? parsed : [];
  } catch (_) {
    return [];
  }
}

/**
 * @param {{ active: boolean; flowId: string|null; stepId: string|null; answers: object; draft: object; meta: { startedAt?: number; lastUpdatedAt?: number } } | null} state
 */
export function saveFlowState(state) {
  try {
    if (typeof window === "undefined" || !window.localStorage) return;
    window.localStorage.setItem(FLOW_KEY, JSON.stringify(state ?? null));
  } catch (_) {
    // ignore
  }
}

/**
 * @returns {{ active: boolean; flowId: string|null; stepId: string|null; answers: object; draft: object; meta: { startedAt?: number; lastUpdatedAt?: number } } | null}
 */
export function loadFlowState() {
  try {
    if (typeof window === "undefined" || !window.localStorage) return null;
    const raw = window.localStorage.getItem(FLOW_KEY);
    if (raw == null) return null;
    const parsed = JSON.parse(raw);
    if (parsed && typeof parsed === "object" && parsed.active === true && parsed.flowId) {
      return parsed;
    }
    return null;
  } catch (_) {
    return null;
  }
}
